import React from 'react'
import { cn } from '../../lib/cn'

const toneClass = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
  neutral: 'badge-neutral',
  social: 'badge bg-social-100 text-social-800',
  hospital: 'badge bg-hospital-50 text-hospital-700',
}

/**
 * @param {{ tone?: keyof typeof toneClass, dot?: boolean, pulse?: boolean }} props
 */
export function Badge({ tone = 'neutral', dot = false, pulse = false, className, children, ...rest }) {
  return (
    <span className={cn(toneClass[tone] || toneClass.neutral, className)} {...rest}>
      {dot && (
        <span
          className={cn('inline-block h-1.5 w-1.5 rounded-full bg-current', pulse && 'animate-pulse')}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  )
}

export default Badge
